class Auth {
    name;
    email;
    token;
    user;
    is_admin;
    
    constructor(name, email, token, user, is_admin) {
        this.name = name;
        this.email = email;
        this.token = token;
        this.user = user;
        this.is_admin = is_admin;
    }
}

export default Auth;
